import React, {  useState } from 'react'
import { useHistory } from 'react-router-dom';
import Title from '../../../components/Title';
import { useTranslation } from 'react-i18next';
import LimitationBlock from '../../../components/industries/LimitationBlock';
import IndustrySelection from '../../../components/industries/IndustrySelection';

const IndusriesIndex = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [currentIndustry, setCurrentIndustry] = useState({})

  return ( <>
      <Title
        main={t("menu.industries")}
        group={false}
        onBack={()=>(history.goBack())}>
      </Title>
      <IndustrySelection currentIndustry={currentIndustry}  setCurrentIndustry={setCurrentIndustry}/>
      <LimitationBlock currentIndustry={currentIndustry}/>
  </> );
}

export default IndusriesIndex;